import React from 'react';
import $ from 'jquery';

import BaseClass from '@/pages/BaseClass';
import areaList from '@/utils/area';

import {authUrl, CommonValue, httpPost, message, ngUrl, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);

        this.state = {
            'provinceList': [],
            'cityList': [],
            'areaList': [],
            'schoolList': [],
            'enrolYearList': [],
            'gradeList': [],
            'classesList': [],

            'info': {
                "cardNo":"",
                "province": "",
                "city": "",
                "area": "",
                "schoolId": "",
                "enrolYear": "",
                "grade": "",
                "classes": "",
                "name": "",
                "mobile": "",
                "smsVeriCode": "",
                "username": "",
                "password": "",
                "sourceType": "5",
                "agree": false,
            },
            'timer': 0,
        };
    }

    componentDidMount() {
        let cardNo = CommonValue.get('cardNo');
        if (cardNo) {
            let info = this.state.info;
            info.cardNo = cardNo;
            this.setState({
                'info': info,
            });
        }

        this.getProvinceList();
        this.getEnrolYearList();
        this.getGradeList();
        this.getClassesList();
    }

    getProvinceList() {
        this.setState({
            'provinceList': areaList[100000]
        });
    }

    getCityList(provinceCode) {
        this.setState({
            'cityList': areaList[provinceCode]
        });
    }

    getAreaList(cityCode) {
        this.setState({
            'areaList': areaList[cityCode] || {}
        });
    }

    provinceChange(province) {
        let info = this.state.info;
        info.province = province;
        this.setState({
            'info': info,
        });
        this.getCityList(province);
    }

    cityChange(city) {
        let info = this.state.info;
        info.city = city;
        info.area = '';
        this.setState({
            'info': info,
        });
        this.getAreaList(city);
    }

    areaChange(area) {
        let info = this.state.info;
        info.area = area;
        this.setState({
            'info': info,
        });
        this.getSchoolList();
    }

    getSchoolList() {
        let url = pcUrl('/school', {
            'province': areaList[100000][this.state.info.province],
            'city': areaList[this.state.info.province][this.state.info.city],
            'area': this.state.info.area ? areaList[this.state.info.city][this.state.info.area] : '',
        });
        httpPost(url, {}, 'get', {
            'rawResponse': true
        }).then(data => {
                this.setState({
                    'schoolList': data.rows
                });
            });
    }

    getEnrolYearList() {
        let url = pcUrl('/dict/data?dictType=student_enrol_year');
        httpPost(url, {}, 'get', {
            'rawResponse': true
        }).then(data => {
            this.setState({
                'enrolYearList': data.rows
            });
        });
    }

    getGradeList() {
        let url = pcUrl('/dict/data?dictType=student_grade');
        httpPost(url, {}, 'get', {
            'rawResponse': true
        }).then(data => {
            this.setState({
                'gradeList': data.rows
            });
        });
    }

    getClassesList() {
        let url = pcUrl('/dict/data?dictType=student_classes');
        httpPost(url, {}, 'get', {
            'rawResponse': true
        }).then(data => {
            this.setState({
                'classesList': data.rows
            });
        });
    }

    sendValidateCode() {
        if (this.state.timer) return false;
        let mobile = this.state.info.mobile;
        if (!mobile) {
            message('请输入手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }

        let preg = /^1\d\d\d{8}$/;
        if (!mobile.match(preg)) {
            message('请输入正确的手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }

        let url = authUrl('/register/sendVeriCode');
        let param = {mobile};
        httpPost(url, param)
            .then(() => {
                this.setState({
                    'timer': 20,
                });
                let loop = window.setInterval(() => {
                    let timer = this.state.timer;
                    this.setState({
                        'timer': --timer,
                    });

                    if (timer == 0) {
                        window.clearInterval(loop);
                        return false;
                    }
                }, 1000);
            });
    }

    submit() {
        let url = authUrl('/register');
        let param = JSON.parse(JSON.stringify(this.state.info));

        if (!param.province.length) {
            message('请选择省份');
            $('[name="province"]').trigger('focus');
            return false;
        }
        param.province = areaList[100000][this.state.info.province];
        if (!param.city.length) {
            message('请选择城市');
            $('[name="city"]').trigger('focus');
            return false;
        }
        param.city = areaList[this.state.info.province][this.state.info.city];
        if (param.area && param.area.length) {
            param.area = areaList[this.state.info.city][this.state.info.area];
        } else {
            delete param.area;
        }

        if (!param.schoolId.length) {
            message('请选择学校');
            $('[name="schoolId"]').trigger('focus');
            return false;
        }
        if (!param.enrolYear.length) {
            message('请选择入学年份');
            $('[name="enrolYear"]').trigger('focus');
            return false;
        }
        if (!param.grade.length) {
            message('请选择年级');
            $('[name="grade"]').trigger('focus');
            return false;
        }
        if (!param.classes.length) {
            message('请选择班级');
            $('[name="classes"]').trigger('focus');
            return false;
        }
        if (!param.name.length) {
            message('请输入姓名');
            $('[name="name"]').trigger('focus');
            return false;
        }
        if (!param.mobile.length) {
            message('请输入手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }
        let preg = /^1\d\d\d{8}$/;
        if (!param.mobile.match(preg)) {
            message('请输入正确的手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }
        param.username = param.mobile;

        if (!param.smsVeriCode.length) {
            message('请输入短信验证码');
            $('[name="smsVeriCode"]').trigger('focus');
            return false;
        }
        if (!param.password.length) {
            message('请输入密码');
            $('[name="password"]').trigger('focus');
            return false;
        }
        if (!param.agree) {
            message('请同意用户许可协议和隐私政策');
            return false;
        }

        httpPost(url, param)
            .then(data => {
                message('用户注册成功，您可以继续登录', 'success');
                this.props.history.goBack();
            });
    }

    render() {
        return (
            <div className="body register-page">
                <div className="register-inner">
                    <div className="login-form">
                        <div className="captain">
                            <h3>请绑定个人信息</h3>
                        </div>
                        <form onSubmit={e => {
                            e.preventDefault();
                            this.submit()
                        }}>
                            <div className="form-body">
                                <div className="form-row">
									<span className="label">地区</span>
                                    <div className="form-value">
                                        <div className="row" style={{margin: 0}}>
                                            <div className="col-4" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                                                <select className="input-text" name="province" placeholder="请选择省份"
                                                       onChange={e => this.provinceChange(e.target.value)}>
                                                    <option>——请选择——</option>
                                                    {Object.keys(this.state.provinceList).map((code) => (
                                                        <option value={code}>{this.state.provinceList[code]}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-4" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                                                <select className="input-text" name="city" placeholder="请选择城市"
                                                        onChange={e => this.cityChange(e.target.value)}>
                                                    <option>——请选择——</option>
                                                    {Object.keys(this.state.cityList).map((code) => (
                                                        <option value={code}>{this.state.cityList[code]}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-4" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                                                <select className="input-text" name="area" placeholder="请选择区县"
                                                        onChange={e => this.areaChange(e.target.value)}>
                                                    <option>——请选择——</option>
                                                    {Object.keys(this.state.areaList).map((code) => (
                                                        <option value={code}>{this.state.areaList[code]}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
                                    <span className="label">学校</span>
                                    <select name="schoolId" onChange={e => this.bindModel(e)} className="input-text">
                                        <option>——请选择——</option>
                                        {this.state.schoolList.map(row => (
                                            <option value={row.id}>{row.name}</option>
                                        ))}
                                    </select>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
									<span className="label">入学年份</span>
                                    <select name="enrolYear" onChange={e => this.bindModel(e)} className="input-text">
                                        <option>——请选择——</option>
                                        {this.state.enrolYearList.map(item => (
                                            <option value={item.dictValue}>{item.dictLabel}</option>
                                        ))}
                                    </select>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
									<span className="label">年级</span>
                                    <select name="grade" onChange={e => this.bindModel(e)} className="input-text">
                                        <option>——请选择——</option>
                                        {this.state.gradeList.map(item => (
                                            <option value={item.dictValue}>{item.dictLabel}</option>
                                        ))}
                                    </select>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
                                    <span className="label">班级</span>
                                    <select name="classes" onChange={e => this.bindModel(e)} className="input-text">
                                        <option>——请选择——</option>
                                        {this.state.classesList.map(item => (
                                            <option value={item.dictValue}>{item.dictLabel}</option>
                                        ))}
                                    </select>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
									<span className="label">姓名</span>
                                    <input name="name" value={this.state.info.name} onChange={e => this.bindModel(e)}
                                           className="input-text"/>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
									<span className="label">家长手机号</span>
                                    <span className="input-wrapper">
										<input name="mobile" value={this.state.info.mobile}
                                               onChange={e => this.bindModel(e)} className="input-text"/>
										<span className="before-node">+86</span>
									</span>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
									<span className="label">短信验证码</span>
                                    <span className="input-wrapper spec">
										<input name="smsVeriCode" onChange={e => this.bindModel(e)} className="input-text"/>
										<span className="after-node">
											{this.state.timer == 0 ? (
                                                <button className="button button-border border-blue"
                                                        onClick={() => this.sendValidateCode()}
                                                        type="button">发送验证码</button>
                                            ) : (
                                                <button className="button button-border border-gray"
                                                        type="button">等待{this.state.timer >= 10 ? this.state.timer : ('0' + this.state.timer)}秒</button>
                                            )}
										</span>
									</span>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
									<span className="label">登录密码</span>
                                    <input name="password" type="password" onChange={e => this.bindModel(e)} className="input-text"/>
                                    <div className="clear"></div>
                                </div>
                                <div style={{'height': '1px'}}></div>
                                <div className="form-row text-center">
                                    <label>
                                        <input type="checkbox" onChange={e => {
                                            this.changeInfo('agree', e.target.checked);
                                        }}/>
                                        我已阅读并接受
                                        <a href="file/UserAgreement.html" target="_blank">《用户许可协议》</a>
                                        和
                                        <a href="file/PrivacyPolicy.html" target="_blank">《隐私政策》</a>
                                    </label>
                                </div>
                                <div className="form-row text-center" style={{'margin': '1em 0 1em 0'}}>
                                    <button className="button submit-button button-blue">立即注册</button>
                                </div>
                                <div className="text-center">
                                    <a href={ngUrl('login')} className="text-blue">已有账号，直接登录</a>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="height-30"></div>
                </div>
            </div>
        );
    }
}

